import { render, staticRenderFns } from "./PreassessmentsList.vue?vue&type=template&id=3efeeb6f&"
import script from "./PreassessmentsList.vue?vue&type=script&lang=js&"
export * from "./PreassessmentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports